export default __webpack_public_path__ + "static/media/Logo.16803c5e.svg";